import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import BottomNavigation from './BottomNavigation';
import Stars from './Stars';

const Layout = () => {
  const { theme } = useTheme();

  return (
    <div 
      className="app-layout" 
      style={{ 
        background: `linear-gradient(180deg, ${theme.colors[0]} 0%, ${theme.colors[1]} 100%)`,
        minHeight: '100vh',
        position: 'relative'
      }}
    >
      <Stars />
      <main className="app-content" style={{ position: 'relative', zIndex: 1 }}>
        <Outlet />
      </main>
      <BottomNavigation />
    </div>
  );
};

export default Layout;
